import { render, staticRenderFns } from "./xg-manage.vue?vue&type=template&id=1f3bd734&scoped=true&"
import script from "./xg-manage.vue?vue&type=script&lang=js&"
export * from "./xg-manage.vue?vue&type=script&lang=js&"
import style0 from "./xg-manage.vue?vue&type=style&index=0&id=1f3bd734&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3bd734",
  null
  
)

export default component.exports